module.exports = __webpack_public_path__ + "img/invitation-title.1d33a639.png";